import { GenderFemale, GenderIntersex, GenderMale } from "@phosphor-icons/react"
import { cn } from "@/lib/utils"
import { Gender } from "@/types/__generated__/union-types"

interface GenderIconProps extends React.HtmlHTMLAttributes<HTMLSpanElement> {
  className?: string
  gender?: Gender
  size?: number
}

export const getGenderIcon = (gender: Gender) => {
  switch (gender) {
    case "MALE":
      return GenderMale
    case "FEMALE":
      return GenderFemale
    case "OTHER":
      return GenderIntersex
    case "UNKNOWN":
      return null
  }
}

export const GenderIcon = ({ className = "h-8 w-8 min-w-8", gender, size = 24, ...props }: GenderIconProps) => {
  if (!gender) return null

  const GenderIconSvg = getGenderIcon(gender)
  return GenderIconSvg ? (
    <span
      className={cn("bg-ochre-surface flex shrink-0 items-center justify-center rounded-full", className)}
      {...props}>
      <GenderIconSvg size={size} className="text-on-ochre-surface" />
    </span>
  ) : null
}
